import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/header-sidebar-icon-nav.module.css";
import { ColorScheme, NavLinkWithIcon } from "../types/index.js";
import { css } from "../utils/emotion.js";
import Icon from "./Icon.js";
import SmartLink from "./SmartLink.js";

interface Props {
  scheme: ColorScheme;
  navLinks: NavLinkWithIcon[];
  isPreview: boolean;
  hoverTextDirection: "left" | "right";
  iconClassName?: string;
}

const HeaderSidebarIconNav: FunctionComponent<Props> = ({
  scheme,
  navLinks,
  isPreview,
  hoverTextDirection,
  iconClassName,
}) => {
  if (!navLinks.length) return null;

  return (
    <ul
      className={ClassNames(
        styles.HeaderSidebarIconNav,
        css({ color: scheme.primary.text }),
      )}
    >
      {navLinks.map(({ href, icon, children, title }, index) => (
        <li key={index} className={styles.HeaderSidebarIconNav__ListItem}>
          <SmartLink
            anchorAttrs={{
              className: styles.HeaderSidebarIconNav__Item,
              href,
              "aria-label": title,
            }}
            isPreview={isPreview}
          >
            <Icon
              className={ClassNames(
                styles.HeaderSidebarIconNav__Icon,
                css({ fill: scheme.main.text }),
                iconClassName,
              )}
              glyph={icon}
            />
            <span
              className={ClassNames(
                styles.HeaderSidebarIconNav__Text,
                {
                  [styles["HeaderSidebarIconNav__Text--left"]]:
                    hoverTextDirection === "left",
                },
                css({
                  backgroundColor: scheme.primary.background,
                  "&::before": {
                    [hoverTextDirection === "right"
                      ? "borderRightColor"
                      : "borderLeftColor"]: scheme.primary.background,
                  },
                }),
              )}
            >
              {children}
            </span>
          </SmartLink>
        </li>
      ))}
    </ul>
  );
};

export default HeaderSidebarIconNav;
